import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import LoadingAnimation from '../LoadingAnimation';

export default function ProgressDialog({
  open, setOpen, header,
}) {
  const dialogRef = useRef(null);

  const handleClose = () => {
    if (setOpen) {
      setOpen(false);
    }
  };

  // Animation variants for the dialog
  const backdropVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.9, y: "-5%" },
    visible: { opacity: 1, scale: 1, y: "0%" },
    exit: { opacity: 0, scale: 0.9, y: "5%" },
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          ref={dialogRef}
          className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-25 backdrop-blur-none"
          variants={backdropVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
          onClick={handleClose} // Optional: close on backdrop click
        >
          <motion.div
            className="bg-white p-6 sm:p-8 rounded-xl w-full max-w-md mx-4"
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            transition={{ type: "spring", damping: 18, stiffness: 200 }}
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
          >
            <div className="text-center">
              <LoadingAnimation text={header || 'Processing...'} />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

ProgressDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func,
  header: PropTypes.string, // header is now optional as LoadingAnimation has a default
};

ProgressDialog.defaultProps = {
  setOpen: () => { },
  header: 'Processing...', // Default header text
};
